import React from 'react';
import { aboutContent } from '../data/mockData';
import { useTheme } from '../context/ThemeContext';

const AboutSection = () => {
  const { isDark } = useTheme();

  return (
    <section className={isDark ? 'bg-neutral-800' : 'bg-white'}>
      {/* Tradition Section */}
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div 
          className="h-64 lg:h-auto min-h-[300px] bg-cover bg-center"
          style={{ backgroundImage: `url(${aboutContent.tradition.image})` }}
        />
        <div className="p-8 md:p-12 lg:p-16 flex flex-col justify-center">
          <h2 className="text-2xl md:text-3xl font-bold text-lime-500 mb-6">
            {aboutContent.tradition.title}
          </h2>
          <p className={`leading-relaxed text-lg ${isDark ? 'text-neutral-300' : 'text-neutral-600'}`}>
            {aboutContent.tradition.description}
          </p>
        </div>
      </div>

      {/* Quality Section */}
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="p-8 md:p-12 lg:p-16 flex flex-col justify-center order-2 lg:order-1">
          <h2 className="text-2xl md:text-3xl font-bold text-lime-500 mb-6">
            {aboutContent.quality.title}
          </h2>
          <p className={`leading-relaxed text-lg ${isDark ? 'text-neutral-300' : 'text-neutral-600'}`}>
            {aboutContent.quality.description}
          </p>
        </div>
        <div 
          className="h-64 lg:h-auto min-h-[300px] bg-cover bg-center order-1 lg:order-2"
          style={{ backgroundImage: `url(${aboutContent.quality.image})` }}
        />
      </div>
    </section>
  );
};

export default AboutSection;
